window.globalThis = window.globalThis || window;
